import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/services/apiService';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-recipt',
  templateUrl: './recipt.component.html',
  styleUrls: ['./recipt.component.css']
})
export class ReciptComponent {

  requests:any[]=[];
  pages: number[] = [];
  currentIndex=1;
  visible: boolean = false;
  selectedItem:any;
  isLoading=true;
  yourTableData :any[]=[];
  fromDate:string|undefined;
  toDate:string|undefined;

  billingNumber:number|undefined;
  pvn:string|undefined;
  userName:string|undefined;
  serviceName:string|undefined;
  issueDate:string|undefined;
  paid:string|undefined='';

  constructor(private apiService:ApiService,private datePipe: DatePipe) {
   
    this.fillRequest();
  }

  search(){

    this.isLoading=true;

    this.pages=[];

    var url="Moin/GetAllBillingRequests?PageNumber=1&";

    if(this.userName!="" && this.userName!=null && this.userName!=undefined){
      url+=`username=${this.userName ?? null}&`;
    }

    if(this.fromDate!="" && this.fromDate!=null && this.fromDate!=undefined){
      url+=`fromDate=${this.fromDate ?? null}&`;
    }

    if(this.toDate!="" && this.toDate!=null && this.toDate!=undefined){
      url+=`toDate=${this.toDate ?? null}&`;
    }

    if(this.billingNumber!=null && this.billingNumber!=null && this.billingNumber!=undefined){
      url+=`billingNumber=${this.billingNumber ?? null}&`;
    }

    if(this.serviceName!=null && this.serviceName!=null && this.serviceName!=undefined){
      url+=`serviceName=${this.serviceName ?? null}&`;
    }

    if(this.paid!=null && this.paid!=null && this.paid!=undefined){
      url+=`paid=${this.paid ?? null}&`;
    }

    if(this.pvn!="" && this.pvn!=null && this.pvn!=undefined){
      url+=`voucherNumber=${this.pvn ?? null}&PageSize=999999999&`;
    }


    if(!url.includes("PageSize")){
      url+="PageSize=10";
    }

    var request=this.apiService.get(url,environment.govnet);

    request.subscribe(response=>{


      
      var data=response.data.records;
      this.requests=data.reverse();

      this.pages=[];

      this.isLoading=false;
      
      for (let i = 1; i <= response.data.totalPages; i++) {
        this.pages.push(i);
      }


    });

  }

  exportToExcel() {

    this.isLoading=true;

    this.yourTableData=[];

    var url=`Moin/GetAllBillingRequests?PageNumber=1&PageSize=999999999&fromDate=${this.fromDate}&toDate=${this.toDate}&`;

    if(this.userName!="" && this.userName!=null && this.userName!=undefined){
      url+=`username=${this.userName ?? null}&`;
    }

    if(this.billingNumber!=null && this.billingNumber!=null && this.billingNumber!=undefined){
      url+=`billingNumber=${this.billingNumber ?? null}&`;
    }

    if(this.serviceName!=null && this.serviceName!=null && this.serviceName!=undefined){
      url+=`serviceName=${this.serviceName ?? null}&`;
    }

    if(this.paid!=null && this.paid!=null && this.paid!=undefined){
      url+=`paid=${this.paid ?? null}&`;
    }

    if(this.pvn!="" && this.pvn!=null && this.pvn!=undefined){
      url+=`voucherNumber=${this.pvn ?? null}`;
    }

    var request=this.apiService.get(url,environment.govnet);

    request.subscribe(response=>{

      this.isLoading=false;

      var items = response.data.records as any[];

      items.map(item=>{

        this.yourTableData.push({
          'billingNumber':item?.billingNumber,
          'voucherNumber':item?.billingInfo?.paymentInfo?.pvn,
          'userName':item?.userName,
          'service':item?.billingTyps?.service,
          'isPaid':item?.billingInfo?.billStatus=='2'?'مدفوع':'غير مدفوع',
          'issueDate' :this.datePipe.transform(item?.billingInfo?.issueDate,"dd-MM-yyyy"),
          'bank 1 name':item.billingInfo?.subPmtDetails[0]?.banksCode.bankName,
          'bank 1 iban':item.billingInfo?.subPmtDetails[0]?.banksCode.bankIban,
          'bank 1 amount':item.billingInfo?.subPmtDetails[0]?.amount,
          'bank 2 name':item.billingInfo?.subPmtDetails[1]?.banksCode.bankIban,
          'bank 2 iban':item.billingInfo?.subPmtDetails[1]?.banksCode.bankName,
          'bank 2 amount':item.billingInfo?.subPmtDetails[1]?.amount,
        });

      });
      
      // Example data, replace with your actual data
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.yourTableData);
    
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
      // // Generate XLSX file and send to client
       XLSX.writeFile(wb, 'reciept.xlsx');

    });

  }

  fillRequest(){

    var request=this.apiService.get('Moin/GetAllBillingRequests?PageSize=10&PageNumber=1',environment.govnet);

    request.subscribe(response=>{
      var data =response.data.records as any[];

      this.requests=data.reverse();

      this.isLoading=false;

      for (let i = 1; i <= response.data.totalPages; i++) {
        this.pages.push(i);
      }

    });

  }


  goNextIndex(){

    if(this.currentIndex<this.pages.length){
      var newIndex=this.currentIndex+1;
  
      this.updatePagination(newIndex);
    }
  }

  goPrevIndex(){

    if(this.currentIndex!=1){

      var newIndex=this.currentIndex-1;

      this.updatePagination(newIndex);
    }
  }


  updatePagination(index:number){

    this.isLoading=true;


    var request=this.apiService.get(`Moin/GetAllBillingRequests?PageSize=10&PageNumber=${index}`,environment.govnet);

    this.currentIndex=index;

    request.subscribe(response=>{

      var data=response.data.records;
      this.requests=data.reverse();

      this.isLoading=false;

    });
  }

  showSubPaymentDetails(info:any){
    this.selectedItem=info;
    this.visible=true;

  }

  async getRecipt(billNo:string){
    
    this.isLoading=true;

    try{
      var request=this.apiService.get(`Moin/GetRecipt?billnumber=${billNo}`,environment.govnet);

      var response= await firstValueFrom(request);

      this.downloadMinioFile(response.data.value);
    }catch(ex){

    }

    setTimeout(() => {
      this.isLoading=false;
    }, 6000);

  }

  downloadMinioFile(objectId:string){

    this.apiService.minioRedirectFile(objectId);

  }

}
